import React, { useState, useEffect } from "react";
import Button from "../../../components/Button/Button";
import { MdAddBox } from "react-icons/md";
import Table from "../../../components/Table/Table";
import AddProduct from "./AddProduct/AddProduct";
import { ProductService } from "./ProductService";
import Loader from "../../../components/Loader/Loader";
import { toast } from "react-toastify";

const Products = () => {
  const [isShowAddProductDialog, setIsShowAddProductDialog] =
    useState<boolean>(false);
  const [data, setDate] = useState<any>([]);
  const [categories, setCategories] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const columns = ["Image", "Title", "Description", , "Price", ""];
  const columnsKeys = ["image_url", "title", "description", "price"];

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, [isShowAddProductDialog]);

  const fetchProducts = async () => {
    setLoading(true);
    ProductService.getProducts().then((res) => {
      setDate(res.data);
      setLoading(false);
    });
  };

  const fetchCategories = () => {
    ProductService.getCategories().then((res) => {
      console.log("CAT", res);
      const cat = res.data.map((item: any) => {
        return {
          value: item.id,
          label: item.title,
        };
      });
      setCategories(cat);
    });
  };

  const onDelete = async (item: any) => {
    setLoading(true);
    const res: any = await ProductService.deleteProduct(item.id);
    if (res.status === 200) {
      toast.success("Product deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      fetchProducts();
    } else {
      setLoading(false);
      toast.error("Something wents wrong!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setLoading(false);
    }
  };

  const onEdit = async (item: any) => {
    console.log(item);
  };

  return (
    <div className="bg-white h-full w-full rounded-lg p-2">
      {loading && (
        <div className="fixed w-screen h-screen top-0 right-0 z-30 bg-black bg-opacity-10 flex items-center justify-center">
          <Loader />
        </div>
      )}
      {isShowAddProductDialog && (
        <AddProduct
          onClose={() => setIsShowAddProductDialog(false)}
          categories={categories}
        />
      )}
      <div className="flex w-full justify-between items-center">
        <h3 className="text-xl font-semibold">Products</h3>
        <Button
          onClick={() => setIsShowAddProductDialog(!isShowAddProductDialog)}
          className="!bg-blue-500 text-white flex gap-2 items-center !mt-0"
          disabled={false}
        >
          <MdAddBox />
          Add Product
        </Button>
      </div>
      <Table
        columns={columns}
        data={data}
        columnsKeys={columnsKeys}
        onEdit={(item: any) => onEdit(item)}
        onDelete={(item: any) => onDelete(item)}
      />
    </div>
  );
};

export default Products;
